<template>
  <div class="trip-detail-main" @click="tripDetailContainerClicked">
    <div class="trip-detail-left">

      <div class="detail-row">
        <div class="detail-left">{{containerNo}}</div>
        <div class="detail-right">{{contSzTyp}}</div>
      </div>
      <div class="detail-row">
        <div class="detail-left">{{consignmentNo}}</div>
        <div class="detail-right">{{movementType}}</div>
      </div>
      <div class="detail-row">
        <div class="detail-left">{{billToName}}</div>
        <div class="detail-right">{{depDestCodeArea}}</div>
      </div>
      
    </div>
    <div class="trip-detail-right">
      <img src="https://dsmapi.logistics.systems/dsm6gIcons/TooltipInfo.png">
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed : {
    contSzTyp : function () {
      return `${this.contSize}${this.contType}`
    },
    depDestCodeArea : function () {
      return `[${this.fromDestCode} (${this.fromArea}) - ${this.toDestCode} (${this.toArea})]`
    },

  },
  data: function() {
    return {
      containerNo : '',
      consignmentNo : '',
      billToName : '',
      contSize : '',
      contType : '',
      movementType : '',
      fromDestCode : '',
      fromArea : '',
      toDestCode : '',
      toArea : '',
      canClick : true,
    }
  },
  props: {
    tripData : {type: Object, default : function() { return null }},
    backgroundTransparent : {type : Boolean, default : false},
  },
  methods: {
    populateData : function (data) {
      this.containerNo = data['ContainerNo']
      this.consignmentNo = data['ConsignmentNo']
      this.billToName = data['BillToName']
      this.contSize = data['ContSize']
      this.contType = data['ContType']
      this.movementType = data['MovementType']
      this.fromDestCode = data['FromDestCode']
      this.fromArea = data['FromArea']
      this.toDestCode = data['ToDestCode']
      this.toArea = data['ToArea']
    },
    tripDetailContainerClicked : function (e) {
      let status = '';
      console.log(this.tripData);
      let parent = e.target.parentNode.parentNode.parentNode // must be trip detail main if not return D:
      if (!this.tripData['PickupOut']) {
        status = 'Pick Up'
      } else if (!this.tripData['DropoffOut']) {
        status = 'Drop Off'
      } else {
        status = 'No Status'
      }

      this.$emit('status',e, parent, status, this.tripData)
    },
  },
  mounted() {
    // let mainDoc = document.querySelector('.trip-detail-main');
    // if (this.backgroundTransparent) {
    //   console.log('masuk');
    //   mainDoc.style.setProperty('background-color', '')
    // } else {
    //   mainDoc.style.setProperty('background-color', 'white')
    // }
    if (this.tripData) {
      this.populateData(this.tripData)
    }
    
  },
  watch: {
    tripData : {
      handler : function (val) {
        if (val) {
          this.populateData(this.tripData)
        }
      },deep : true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.trip-detail-main {
  cursor: pointer;
  max-width : 475px;
  min-height: 66px;
  width: 100%;
  height: fit-content;
  border: 1px solid black;
  display: flex;
  padding: 5px;
  border-radius: 5px;
  background-color: white;

  > .trip-detail-left {
    width: 100%;
    height: 100%;
  
    > .detail-row {
      width: 100%;
      display: flex;
      justify-content: space-between;

      > .detail-left {
        max-width : 200px;
        font-weight: 700;
        word-wrap: break-word;
        text-align : left;
      }

      > .detail-right {
        text-align: right;
      }
    }
  }

  > .trip-detail-right {
    width: fit-content;
    min-height: 100%;
    display: flex;
    align-items: flex-end;
   
 
    > img {
      width: 20px;
      height : 20px;
      cursor: help;
    }
  }

}


</style>